import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import AcademicSessions from "../../../../shared/components/archives/AcademicSessions";
import StudentCategoryNavigationBar from "../../../../shared/components/archives/students/StudentCategoryNavigationBar";
import useFetchArchivedStudents from "../../../../shared/api/archives/students/useFetchArchivedStudents";
import ArchivedStudentTable from "../../../../shared/components/archives/students/ArchivedStudentTable";

export default function GraduatedStudents() {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const session = query.get("session");

  const { schoolId, category } = useParams();
  const navigate = useNavigate();
  const [data, loading, reset] = useFetchArchivedStudents(session, "graduated");

  function handleSelectSession(params) {
    navigate(
      `/${schoolId}/archives/graduated-students/${category}?session=${params?.session}`
    );
  }

  return (
    <div>
      <div className="page">
        <h1 className="page_title mb-5">Graduated Students</h1>

        <AcademicSessions
          handleSelect={handleSelectSession}
          session={session}
        />

        <StudentCategoryNavigationBar active={category} reset={reset} />

        <div className="main_content">
          <ArchivedStudentTable data={data} loading={loading} />
        </div>
      </div>
    </div>
  );
}
